import { PricingPage } from '@/components/pricing/pricing-page';

export function Pricing() {
  return <PricingPage />;
}